export default {"id":"487b9e77","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}